import {defaults} from './../../../shared/constants/defaults';
import {LocalityResponsePayload} from './../../../shared/models/api/localityResponsePayload';
import {createSlice, PayloadAction, SliceCaseReducers} from '@reduxjs/toolkit';
import {AppActions} from '../../actions';

export interface LocalitiesState {
  list: LocalityResponsePayload[] | null;
  current: LocalityResponsePayload | null;
  isDeterminated: boolean;
}

const initialState: LocalitiesState = {
  list: null,
  current: defaults.locality,
  isDeterminated: false,
};

export const localitiesSlice = createSlice<LocalitiesState, SliceCaseReducers<LocalitiesState>>({
  name: '@@eskmo/localities',
  initialState,
  reducers: {
    setLocalities: (state, action: PayloadAction<LocalityResponsePayload[]>) => {
      state.list = action.payload;
    },
    setCurrentLocality: (state, action: PayloadAction<LocalityResponsePayload>) => {
      state.current = action.payload;
      state.isDeterminated = true;
    },
  },
  extraReducers: {
    [AppActions.Reset]: () => {
      return initialState;
    },
  },
});

export const localities = localitiesSlice.reducer;
